import moment from 'moment';
import MediumEditor from 'medium-editor'

window.preventDoubleSubmit = function(el, e) {
    const lockClass = 'formSubmitted';
    if(el.classList.contains(lockClass)) {
        e.preventDefault();
        return false;
    }
    el.classList.add(lockClass);
    return true;
}

window.preventDoubleClick = function(el, e) {
    const lockClass = 'buttonClicked';
    if(el.classList.contains(lockClass)) {
        e.preventDefault();
        return false;
    }
    el.classList.add(lockClass);
    return true;
}

window.clickonce = function(id) {
    id.innerHTML = 'Loading...';
    id.classList.add('loading', 'disabled');
    id.disabled = true;
}

window.ServerTimeClock = function($el) {
    this.elements = $el || [];
    this.updateClock();
};

window.ServerTimeClock.prototype.updateClock = function() {
    if(this.elements.length > 0 ) {
        const now = this.getCurrentTime();

        const time = now.format(serverTimeformat);
        this.elements.text(time);
        const sleep = Math.max(1000 - now.milliseconds(), 1);
        const self = this;
        setTimeout(() => { self.updateClock() }, sleep);
    }
};

window.ServerTimeClock.prototype.getCurrentTime = function() {
    return moment()
        .add(serverTimeDiff, 'milliseconds')
        .utcOffset(serverTimeOffset);
};

window.serverTimeClock = new ServerTimeClock();

function loadGoogleAnalytics(trackingId) {
    if (!trackingId || typeof trackingId !== 'string') {
      console.warn('Invalid or missing Google Analytics tracking ID.');
      return;
    }
  
    if (window.ga || document.getElementById('ga-script')) return;
  
    window.GoogleAnalyticsObject = 'ga';
    window.ga = window.ga || function (...args) {
        (window.ga.q = window.ga.q || []).push(args);
      };
    window.ga.l = +new Date();
  
    const script = document.createElement('script');
    script.id = 'ga-script';
    script.async = true;
    script.src = 'https://www.google-analytics.com/analytics.js';
    document.head.appendChild(script);
  
    ga('create', trackingId, 'auto');
    ga('send', 'pageview');
  }

function dynamicSpacing(full_query, parent_element, minSpacing) {
    // http://stackoverflow.com/a/22431107/238978
    // user1467267 with contributions by Vikas Malhotra
   $(parent_element).each((key, parentElement) => {
      const textElement = $(parentElement).find(full_query);
      $(textElement).css({
         'letter-spacing': 0,
         'word-wrap': 'none',
      });
      let content = $(textElement).html();
      if(!content) return;

      const original = content;
      minSpacing = minSpacing || 0;

      content = content.replace(/(\w|\s)/g, '<span>$1</span>');
      $(textElement).html(content);

      let letter_width = 0;
      let letters_count = 0;
      $(textElement).find('span').each(function() {
         letter_width += $(this).width();
         letters_count++;
      });

      const h1_width = $(parentElement).width();
      let spacing = (h1_width - letter_width) / (letters_count - 1);

      $(textElement).html(original);

      if (spacing < minSpacing) {
         spacing = minSpacing;

         $(parentElement).addClass('fade-text');
      }

      if(letter_width > h1_width){
         $(textElement).css('letter-spacing', spacing);
      }
   });
}

// Should init ASAP as possible
lazySizes.init();

const isIe = function () {
    const ua = window.navigator.userAgent;

    return ua.indexOf('MSIE') > -1 || ua.indexOf('Trident') > -1 || !!document.documentMode;
};

document.addEventListener('DOMContentLoaded', () => {
    if (isIe()) {
        const unsupportedBrowserWarning = document.getElementById('unsupportedBrowserWarning');

        if (unsupportedBrowserWarning != null) {
            unsupportedBrowserWarning.style.display = 'block';
        }
    }
});
const trackingId = window.GA_TRACKING_ID || null;
document.addEventListener('DOMContentLoaded', () => {
    try {
      const consent = JSON.parse(localStorage.getItem('cookieConsent') || '{}');
  
      if (consent.analytics) {
        loadGoogleAnalytics(trackingId);
      }
    } catch (e) {
      console.error('Error cookie consent', e);
    }
  });

$(window).on('load',() => {
   dynamicSpacing('.letter-spacing-fit', '.letter-spacing-fit-container', -10);
});

jQuery(($)=> {
    // Load tooltips
    $('[data-toggle="tooltip"]').tooltip();

    // Load popovers
    $('[data-toggle="popover"]').popover();

    // Init date pickers
    SmoothcompLib.flatpickr('.flatpickr');

    // Zoom to fit in autosize
    if ( $( 'body' ).hasClass( 'autosize' ) ) {

        function zoomtofit() {
            const aspect = (window.innerWidth / window.innerHeight)
            if (aspect > 1.77) {
                var zoom = (window.innerHeight /1080)
            } else {
                var zoom = (window.innerWidth /1920);
            }
            // $('body.autosize').css('zoom',zoom); /* Webkit browsers */
            $('body.autosize').css('transform', `scale(${  zoom  })`);
            $('body.autosize').css('-webkit-transform', `scale(${  zoom  })`);
            $('body.autosize').css('-o-transform', `scale(${  zoom  })`);
            $('body.autosize').css('-ms-transform', `scale(${  zoom  })`);
            $('body.autosize').css('-moz-transform', `scale(${  zoom  })`);
        }

        $(window).on('resize', ()=> {
            zoomtofit();
        });

        zoomtofit();

    }

    $('ul.dropdown-menu [data-toggle=dropdown]').on('click', function(event) {
        // Avoid following the href location when clicking
        event.preventDefault();
        // Avoid having the menu to close when clicking
        event.stopPropagation();
        // opening the one you clicked on
        $(this).parent().toggleClass('open');
    });

    var editors = document.querySelectorAll('.mediumEditor');
    if (editors.length > 0) {
        var SmoothAnchor = MediumEditor.extensions.anchor.extend({
            getFormOpts: function () {
                var targetCheckbox = this.getAnchorTargetCheckbox(),
                    buttonCheckbox = this.getAnchorButtonCheckbox(),
                    opts = {
                        url: this.getInput().value.trim()
                    };

                if (this.linkValidation) {
                    opts.url = this.checkLinkFormat(opts.url);
                }

                if(/smoothcomp.com/.test(opts.url) === false){
                    opts.target = '_blank';
                }

                return opts;
            },
        });

	      var editor = new MediumEditor(editors, {
            toolbar: {
                buttons: [
                    { name: 'bold', contentFA: '<i class="icon icon-bold-1"></i>' },
                    { name: 'italic', contentFA: '<i class="icon icon-italic"></i>' },
                    { name: 'underline', contentFA: '<i class="icon icon-underline"></i>' },
                    { name: 'anchor', contentFA: '<i class="icon icon-link-1"></i>' },
                    { name: 'h2', contentFA: '<i class="icon icon-header"></i><sup>2</sup>' },
                    { name: 'h3', contentFA: '<i class="icon icon-header"></i><sup>3</sup>' }
                ]
            },
            extensions: {
                'anchor': new SmoothAnchor()
            },
            buttonLabels: 'fontawesome'
        });
    }

    serverTimeClock.elements = $('.serverTime');
    serverTimeClock.updateClock();

    // Initialize Semantic UI Dropdown
    SmoothcompLib.dropdown($('.ui.dropdown'));
});
